import React, { useEffect, useState } from 'react';
import CouponCodeOffer from '../couponCodeOfferForInternets';
import request from '../../../utils/request';
import { getProvinceLabel } from '../utils';
import { hasAllFilters } from './utils';

const index = ({
  setFibreInternetData,
  fibreInternetData,
  orderData,
  setIsFormTouched,
  setShowDownloadQuoteFooter,
  error,
  isInternetBackupSelected,
  isFibreEastRestricted
}) => {
  const [couponPage, setCouponPage] = useState(1);
  const [data, setData] = useState({ count: 0, orders: [] });
  const [filters, setFilters] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [searchByOfferCode, setSearchByOfferCode] = useState('');
  const limit = 10;
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));

  const {
    role: { name }
  } = userProfile;

  const payload = {
    province: [getProvinceLabel(orderData)],
    product: ['Fibre Internet'],
    showExpired: false,
    ...filters
  };

  if (name !== 'ADMIN') {
    payload.salesRepId = orderData.orderCreatedBy.id;
  }

  if (searchByOfferCode) {
    payload.offerCode = searchByOfferCode;
  }

  useEffect(() => {
    if (!hasAllFilters(filters)) {
      setData({ orders: [], count: 0 });
      return;
    }
    setIsLoading(true);
    request
      .post(`/offers/filter?page=${couponPage}&limit=${limit}`, payload)
      .then(response => {
        setData({ orders: response.data.rows, count: response.data.count });
        setIsLoading(false);
      });
  }, [filters, couponPage, searchByOfferCode]);

  return (
    <div style={{ paddingTop: '1rem' }}>
      <CouponCodeOffer
        data={data}
        setData={setData}
        setCouponPage={setCouponPage}
        couponPage={couponPage}
        setSelectedCouponData={setFibreInternetData}
        selectedCouponData={fibreInternetData}
        setFilters={setFilters}
        filters={filters}
        limit={limit}
        isLoading={isLoading}
        setSearchByOfferCode={setSearchByOfferCode}
        setIsFormTouched={setIsFormTouched}
        setShowDownloadQuoteFooter={setShowDownloadQuoteFooter}
        error={error}
        isVulcanFlow={orderData.isThisVulcanOrder}
        isFibreModal
        isInternetBackupSelected={isInternetBackupSelected}
        isFibreEastRestricted={isFibreEastRestricted}
      />
    </div>
  );
};

export default index;
